// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modalX__paper-2KiHG";
var _4 = "modalX__top_wrapper-3OHOk";
var _5 = "modalX__title-1KtMO";
var _6 = "modalX__footer-KRbnD";
var _7 = "mobileDialog__root-3xvgj";
var _8 = "mobileDialog__paper-16jCS";
var _9 = "mobileDialog__relink-25L06";
var _a = "mobileDialog__header-3pyVL";
var _b = "mobileDialog__content-SANvN";
var _c = "mobileDialog__footer-1hf3n";
var _d = "modalConfirm__content-pclqF";
var _e = "modalConfirm__error-1-a8f";
var _f = "confirm__button-QjnoF";
var _10 = "mobileDialog__title-YdAy_";
export { _1 as "__esModule", _2 as "mobile", _3 as "modalX__paper", _4 as "modalX__top_wrapper", _5 as "modalX__title", _6 as "modalX__footer", _7 as "mobileDialog__root", _8 as "mobileDialog__paper", _9 as "mobileDialog__relink", _a as "mobileDialog__header", _b as "mobileDialog__content", _c as "mobileDialog__footer", _d as "modalConfirm__content", _e as "modalConfirm__error", _f as "confirm__button", _10 as "mobileDialog__title" }
export default { "__esModule": _1, "mobile": _2, "modalX__paper": _3, "modalX__top_wrapper": _4, "modalX__title": _5, "modalX__footer": _6, "mobileDialog__root": _7, "mobileDialog__paper": _8, "mobileDialog__relink": _9, "mobileDialog__header": _a, "mobileDialog__content": _b, "mobileDialog__footer": _c, "modalConfirm__content": _d, "modalConfirm__error": _e, "confirm__button": _f, "mobileDialog__title": _10 }
